export class CheckboxOptionModel {
    label: string;
    key: string;
    disabled?: boolean;
    tooltip?: string;

    constructor(
        label: string,
        key: string,
        disabled: boolean = false,
        tooltip: string = ''
    ) {
        this.label = label;
        this.key = key;
        this.disabled = disabled;
        this.tooltip = tooltip;
    }
}
